// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35QOa","importantInfo":"styles_importantInfo__37W6F"};